/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { authServiceAccountsDelete } from "../../funcs/authServiceAccountsDelete.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.DeleteServiceAccountRequest$inboundSchema,
};

export const tool$authServiceAccountsDelete: ToolDefinition<typeof args> = {
  name: "auth-service-accounts-delete",
  description: `Delete a service account`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await authServiceAccountsDelete(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
